var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-home"},[_c('div',{staticClass:"p-home-content"},[_c('daily-schedule',{attrs:{"normalSize":"long"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }